<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-news.png" /><span>最新动态</span>
            <router-link :to="{ name: 'LatestPage', query: { name: '最新动态' }}" class="more right">更多</router-link>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 noPadding">
            <div class="swiper-container news-swiper" v-if="slide.length">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(sitem,sidx) in slide" :key="sidx" @click="detailHandle('LatestPageDetail','最新动态', sitem.id)">
                  <img :src="globalVar.imgUrl+sitem.imgurl">
                  <div class="newss-title">
                    <h4>
                      <v-clamp autoresize :max-lines="2">{{sitem.title}}</v-clamp>
                    </h4>
                    <p>
                      <v-clamp autoresize :max-lines="1">{{sitem.content.trim()}}</v-clamp>
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination newsPagination"></div>
              <div class="swiper-button-prev sbtn"></div>
              <div class="swiper-button-next sbtn"></div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 noPadding" style="margin-top: 3%;">
            <div class="page-news-list" v-for="(nitem,nidx) in news.filter((cate,index)=>index<3)" :key="nidx" @click="detailHandle('LatestPageDetail','最新动态', nitem.id)">
              <h3>
                <v-clamp autoresize :max-lines="1">{{nitem.title}}</v-clamp>
              </h3>
              <p>
                <v-clamp autoresize :max-lines="2">{{nitem.content}}</v-clamp>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/p-icon2.png" /><span>公告板</span>
            <router-link :to="{ name: 'BoardPage', query: { name: '公告板' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other-list">
            <div class="page-other-news" v-for="(bitem,bidx) in boardList" :key="bidx" @click="detailHandle('BoardPageDetail','公告板', bitem.id)">
              <p>
                <v-clamp autoresize :max-lines="1">{{bitem.title}}</v-clamp>
              </p>
              <em>{{bitem.createtime}}</em>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/project/p-icon2.png" /><span>服务指南</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in enterList" :key="idx" @click="jump(item)">
              <v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp>
            </p>
          </div>
          <div class="page-search" :class="{bg: searchVal.length}">
            <span>搜索中心</span>
            <input type="text" class="txt" v-model.trim="searchVal" placeholder="请输入关键字搜索" />
            <div class="icon" :class="{iconBg: searchVal.length}" @click="goResult"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon4.png" /><span>宣传片</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 page-pic-list">
            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
            </video-player>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-pic.png" /><span>图片新闻</span>
            <router-link :to="{ name: 'PicPage', query: { name: '图片新闻' }}" class="more right">更多</router-link>
          </div>
          <div class="picwrap">
            <div class="col-xs-6 col-sm-6 col-md-6 page-pic-list" v-for="(pitem,pidx) in picList.filter((cate, idx) => idx < 4)" :key="pidx" @click="detailHandle('PicPageDetail','图片新闻', pitem.id)">
              <img :src="globalVar.imgUrl+pitem.imgurl" />
              <p>
                <v-clamp autoresize :max-lines="2">{{pitem.title}}</v-clamp>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row ggWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6 page-ad" v-for="(item,idx) in adPicWrap" :key="idx" v-show="item.state != -1" @click="topic(item)">
          <img v-if="item.state === 1" :src="globalVar.imgUrl+item.imgurl" />
          <img v-if="item.state === 0" :src="globalVar.imgUrl+item.imgurl" />
        </div>
      </div>
    </div>
    <div class="row otherWrap">
      <div class="container otherWrapList">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-down.png" /><span>新闻素材下载专区</span>
            <router-link :to="{ name: 'BoardPage', query: { name: '新闻素材下载' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other" v-for="(ditem,didx) in downList" :key="didx" @click="detailHandle('BoardPageDetail','新闻素材下载', ditem.id)">
            <p>
              <v-clamp autoresize :max-lines="1">{{ditem.title}}</v-clamp>
            </p><span>{{ditem.createtime}}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-report.png" /><span>媒体报道</span>
            <router-link :to="{ name: 'BoardPage', query: { name: '媒体报道' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other" v-for="(mitem,midx) in mediaList" :key="midx" @click="detailHandle('BoardPageDetail','媒体报道', mitem.id)">
            <p>
              <v-clamp autoresize :max-lines="1">{{mitem.title}}</v-clamp>
            </p><span>{{mitem.createtime}}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-host.png" /><span>主办地厦门动态</span>
            <router-link :to="{ name: 'LatestPage', query: { name: '厦门动态' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other" v-for="(sitem,sidx) in siteList" :key="sidx" @click="detailHandle('LatestPageDetail','厦门动态', sitem.id)">
            <p>
              <v-clamp autoresize :max-lines="1">{{sitem.title}}</v-clamp>
            </p><span>{{sitem.createtime}}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6" v-if="exhibitorList.length">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-exhibitor.png" /><span>展商风采</span>
            <router-link :to="{ name: 'LatestPage', query: { name: '展商风采' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other" v-for="(sitem,sidx) in exhibitorList" :key="sidx" @click="detailHandle('LatestPageDetail','展商风采', sitem.id)">
            <p>
              <v-clamp autoresize :max-lines="1">{{sitem.title}}</v-clamp>
            </p><span>{{sitem.createtime}}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon-style.png" /><span>志愿者风采</span>
            <router-link :to="{ name: 'LatestPage', query: { name: '志愿者风采' }}" class="more right">更多</router-link>
          </div>
          <div class="page-other" v-for="(vitem, vidx) in volunteerList.filter((cate, idx) => idx < 6)" :key="vidx" @click="detailHandle('LatestPageDetail','志愿者风采', vitem.id)">
            <p>
              <v-clamp autoresize :max-lines="1">{{vitem.title}}</v-clamp>
            </p><span>{{vitem.createtime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row partnerWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/news/icon8.png" /><span>合作媒体</span>
          </div>
          <div class="row page-partner-main">
            <!-- <a class="col-xs-6 col-sm-2 col-md-2 page-partner-list" v-for="(item,idx) in partner3.list" :key="idx" :target="globalVar.target" :href="item.url"><img :src="globalVar.imgUrl+item.imgurl"/></a> -->
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner1.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner2.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner3.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner4.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner5.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner6.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner7.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner8.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner9.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner10.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner11.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner12.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner13.png" /></div>
            <div class="col-xs-6 col-sm-2 col-md-2 page-partner-list"><img src="../../static/images/news/partner14.png" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import VClamp from 'vue-clamp'


export default {
  components: {
    subMenuBar,
    VClamp,
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.news,
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" //你的视频地址（必填）
        }],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      searchVal: '',
      enterList: [
        {
          title: '新闻中心组成及职责',
          name: '组织机构',
          pathName: 'ORGNewsPage'
        }, {
          title: '新闻中心服务',
          name: '',
          pathName: 'serviceN'
        }, {
          title: '记者参会指南',
          name: '记者参会指南',
          pathName: 'ReporterPage'
        }, {
          title: '大会采访安排',
          name: '活动预览表',
          pathName: 'ActPage'
        }, {
          title: '大会背景资料',
          name: '',
          pathName: 'AboutCifi'
        }, {
          title: '联络新闻中心',
          name: '联络方式',
          pathName: 'contactN'
        }
      ],
      slide: Array,
      boardList: Array,
      downList: Array,
      mediaList: Array,
      siteList: Array,
      adPicWrap: Array,
      video: Array,
      exhibitorList: Array,
      // partner3: Object,
    }
  },
  async created () {
    await this.init();
    !this.news.length ? await this.getData(5, 0) : '';
    !this.picList.length ? await this.getData(10, 1) : '';
    !this.volunteerList.length ? await this.getData(10, 5) : '';
  },
  async activated () {
    await this.findimgnews();
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    news () {
      return this.$store.state.news.newest;
    },
    picList () {
      return this.$store.state.news.pic;
    },
    volunteerList () {
      return this.$store.state.news.volunteer
    }
  },
  methods: {
    subpagemenu (item) {
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.subName,
        }
      })
    },
    goResult () {
      if (this.searchVal.length) {
        this.$router.push({
          name: 'resultPage',
          query: {
            // name: '新闻详情',
            keyword: encodeURIComponent(this.searchVal)
          }
        })
      }
    },
    jump (item) {
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.name,
        }
      })
    },
    async getData (count, type) {
      let params = {
        count,
        type,
        language: this.globalVar.lang,
      }
      return await this.$store.dispatch("find", params);
    },
    async findimgnews () {
      let params = {
        count: 5,
        position: 2,//2：新闻中心最新动态轮播图
        language: this.globalVar.lang,
      }
      this.slide = [];
      this.slide = await this.$store.dispatch("findimgnews", params);
      this.swiperInte();
    },
    async init () {
      // await this.findimgnews();
      this.boardList = await this.getData(6, 2);//2：公告板
      this.downList = await this.getData(6, 6);//6：新闻素材下载专区
      this.mediaList = await this.getData(6, 3);//3：媒体报道
      this.siteList = await this.getData(6, 4);//4：厦门动态
      this.exhibitorList = await this.getData(6, 9);//9：展商风采
      this.adPicWrap = await this.findAd();//获取广告信息
      let vdata = await this.mainVideo(3);// 3：新文中心宣传视频
      this.video = vdata[0];
      this.playerOptions.sources[0].src = this.globalVar.imgUrl + this.video.fileurl;
      this.playerOptions.poster = this.globalVar.imgUrl + this.video.coverurl;
      // let partnerData = await this.partnersList();
      // this.partner3 = partnerData[2];
    },
    demo () {
      console.log(666)
    },
    swiperInte () {
      this.$nextTick(function () {
        let newsSwiper = new Swiper('.news-swiper', {
          autoplay: 3000,
          speed: 2000,
          grabCursor: true,
          observer: true,
          observeParents: true,
          loop: true,
          autoplayDisableOnInteraction: false,
          pagination: '.swiper-pagination',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',

        })
        if (newsSwiper.slides.length <= 3) {
          newsSwiper.lockSwipes();
        }
      })
    },
    findAd () {
      let params = {
        code: 'B',
        language: this.globalVar.lang
      }
      return this.$store.dispatch("findAd", params);
    },
    async topic (item) {
      let params = {
        id: item.id
      }
      let data = await this.$store.dispatch("clicks", params);
      if (data.isguest === 1) {
        this.$router.push({
          path: '/topic',
          query: {
            gid: data.gid
          }
        })
      } else {
        window.location.href = data.url
      }
    },
    detailHandle (type, name, id) {
      this.$router.push({
        name: type,
        query: {
          name: name,
          id: id
        }
      })
    },
    mainVideo (type) {
      let params = {
        counts: '',
        type,
        language: this.globalVar.lang
      }
      return this.$store.dispatch("mainVideo", params);
    },
    // partnersList(){
    //   let params = {
    //       counts: ''
    //   }
    //   return this.$store.dispatch("partnersList", params);
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import "../../static/function.less";
.latesWrap {
  margin: 2% auto;
  .noPadding {
    padding: 15px;
  }
  .swiper-slide {
    text-align: center;
    .newss-title {
      position: absolute;
      bottom: 0px;
      background: rgba(0, 0, 0, 0.7);
      left: 0;
      right: 0;
      padding: 2% 3% 0% 2%;
      color: #fff;
      text-align: left;
      h4 {
        line-height: 24px;
        font-size: @font16;
      }
      p {
        font-size: @font14;
        margin: 1% 0px 3% 0px;
      }
    }
  }
  .newsPagination {
    bottom: 0px;
  }
  .sbtn {
    background-color: rgba(100, 100, 100, 0.8);
    // color: #fff;
  }
  .page-news-list {
    padding-top: 3%;
    padding-left: 8%;
    margin-bottom: 5%;
    background: url("../../static/images/news/icon-bg.png") top left no-repeat;
    background-size: 7%;
    cursor: pointer;
    &:hover {
      h3 {
        .hoverTxtColor();
      }
    }
    h3 {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
    }
    p {
      font-size: @font14;
      line-height: 20px;
      color: @color767676;
      margin-top: 8px;
      height: 44px;
    }
  }
  .page-other-list {
    margin-top: 2%;
  }
  .page-list {
    margin-top: 3%;
    padding: 0 3%;
    cursor: pointer;
    p {
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover {
        .hoverTxtColor();
      }
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }
  .page-other-news {
    padding: 0px 15px;
    margin-bottom: 1%;
    cursor: pointer;
    &:hover {
      p {
        .hoverTxtColor();
      }
    }
    &:before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 3px;
      background-color: #f00;
      vertical-align: top;
      margin-top: 8px;
      margin-right: 6px;
      border-radius: 50%;
    }
    p {
      font-size: @font14;
      width: 70%;
      display: inline-block;
      color: #303133;
      margin-right: 1%;
    }
    span {
      vertical-align: top;
      margin-top: 2px;
      display: inline-block;
      color: @color767676;
    }
    em {
      color: @color767676;
      float: right;
      margin-top: 2px;
    }
  }
  .picwrap {
    .flexitems(flex-start);
  }
  .page-pic-list {
    padding: 15px 15px 0px 15px;
    cursor: pointer;
    &:hover {
      .hoverTxtColor();
    }
    p {
      font-size: @font14;
      padding: 8px;
      line-height: 20px;
      height: 50px;
    }
  }
}
.page-ad {
  padding: 1% 15px;
}
.otherWrap {
  margin-top: 1%;
  margin-bottom: 4%;
  .otherWrapList {
    .flexitems(flex-start);
  }
  .page-header-news {
    margin-top: 3%;
  }
  .page-other {
    margin-top: 2%;
    padding: 0 3%;
    cursor: pointer;
    &:hover {
      P {
        .hoverTxtColor();
      }
    }
    &:before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 3px;
      background-color: #f00;
      vertical-align: top;
      margin-top: 8px;
      margin-right: 6px;
      border-radius: 50%;
    }
    p {
      display: inline-block;
      width: 70%;
      font-size: @font14;
      color: #303133;
    }
    span {
      color: @color767676;
      float: right;
      margin-top: 2px;
    }
  }
}
.partnerWrap {
  margin: 2% auto;
  text-align: center;
  .page-header-news {
    border-bottom: none;
  }
  .page-partner-main {
    margin-bottom: 4%;
    .page-partner-list {
      margin: 20px 0px;
    }
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .slideMenu {
    display: block;
  }
  .page-search span {
    display: none;
  }
  .page-search .txt {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewsCenter.vue